<template>
	<AssessmentCharacteristics class="leadership-strength-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `sparkles` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.LeadershipStrengthCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "LeadershipStrengthCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.leader.strengths || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
